import { render, staticRenderFns } from "./Cambio.vue?vue&type=template&id=95bbd2fe&scoped=true&"
import script from "./Cambio.vue?vue&type=script&lang=js&"
export * from "./Cambio.vue?vue&type=script&lang=js&"
import style0 from "./Cambio.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Cambio.vue?vue&type=style&index=1&id=95bbd2fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95bbd2fe",
  null
  
)

export default component.exports